import Vue from 'vue'
//自定义指令
Vue.directive('shiro', {
  //禁用
  bind: function(el, binding, vnode) {
    vnode.elm.disabled = true
    el.style.cursor = 'not-allowed'
    for (var i = 0; i < binding.value.length; i++) {
      if (vnode.elm.id == binding.value[i].PERTB001CA00) {
        vnode.elm.disabled = false
        el.style.cursor = 'pointer'
      }
    }
  },
})
Vue.directive('shiroHiden', {
  //隐藏
  bind: function(el, binding, vnode) {
    el.style.display = 'none'
    for (var i = 0; i < binding.value.length; i++) {
      if (vnode.elm.id == binding.value[i].PERTB001CA00) {
        el.style.display = 'inline-block'
      }
    }
  },
})
Vue.directive('no-emoji', {
  inserted(el) {
    el._noEmojiInputHandler = e => {
      const regex = /[\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|[\u2600-\u27BF]]/g
      if (regex.test(e.target.value)) {
        e.target.value = e.target.value.replace(regex, '')
        e.target.dispatchEvent(new Event('input')) // 触发v-model更新
      }
    }
    el.addEventListener('input', el._noEmojiInputHandler)
  },
  unbind(el) {
    if (el._noEmojiInputHandler) {
      el.removeEventListener('input', el._noEmojiInputHandler)
      delete el._noEmojiInputHandler
    }
  },
})
